// extracted by mini-css-extract-plugin
module.exports = {"popper":"top-search-panel_popper__F0RLv","dropdown":"top-search-panel_dropdown__2c9iJ","field":"top-search-panel_field__3gjcd"};